<template>
  <div>
    <b-badge :variant="statusVariant" class="mr-2">
      {{ $t(`customer-signature-status.${signatureStatus}`) }}
    </b-badge>
    <span v-if="signatureReason" class="text-muted">
      — {{ $t(`customer-signature-reason.${signatureReason}`) }}
    </span>
    <p v-if="comment" class="mt-2 mb-0 text-muted">
      <em>{{ comment }}</em>
    </p>
  </div>
</template>

<script>
import axios from 'axios';
import { CondOperator, RequestQueryBuilder } from '@dataui/crud-request';
import { CustomerSignatureStatusEnum } from '@gid/models';
import { CommentActionTypeEnum } from '@gid/models/dist/entities/comment';
import BaseInput from '@gid/vue-common/components/inputs/mixins/BaseInput';

const STATUS_VARIANT = {
  [CustomerSignatureStatusEnum.TAKEN]: 'success',
  [CustomerSignatureStatusEnum.PENDING]: 'info',
  [CustomerSignatureStatusEnum.MISSING]: 'warning',
  [CustomerSignatureStatusEnum.DECLINED]: 'danger',
};

export default {
  mixins: [BaseInput],
  props: {
    jobApiId: { type: String, default: null },
  },
  data() {
    return {
      comment: '',
    };
  },
  computed: {
    signature() {
      return this.value || {};
    },
    signatureStatus() {
      return this.signature.status || CustomerSignatureStatusEnum.MISSING;
    },
    signatureReason() {
      return this.signature.reason || null;
    },
    statusVariant() {
      return STATUS_VARIANT[this.signatureStatus] || 'secondary';
    },
  },
  created() {
    this.loadComment();
  },
  methods: {
    async loadComment() {
      if (!this.jobApiId) return;
      try {
        const queryString = RequestQueryBuilder.create({
          filter: [
            {
              field: 'jobApiId',
              operator: CondOperator.EQUALS,
              value: this.jobApiId,
            },
            {
              field: 'actionType',
              operator: CondOperator.EQUALS,
              value: CommentActionTypeEnum.CUSTOMER_SIGNATURE,
            },
          ],
          sort: [{ field: 'createdAt', order: 'DESC' }],
          limit: 1,
        }).query();
        const res = await axios.get(`/data-api/comment?${queryString}`);
        this.comment = res.data?.[0]?.message || '';
      } catch (e) {
        this.comment = '';
      }
    },
  },
};
</script>
